import {
   HealthcareProviderLocation,
   HealthcareProviderLocationType,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { ServiceLocationId, ServiceLocationType } from '@dreryk/egabinet-healthcare-provider-published-language-api';

import { assertUnreachable } from '~libs.typescript';

import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';
import { appointmentsTranslationKeys } from '../../../../../translations';

const mapHealthcareProviderLocationTypeToServiceLocationType = (
   healthcareProviderLocationType: HealthcareProviderLocationType
): ServiceLocationType => {
   switch (healthcareProviderLocationType) {
      case 'SERVICE_PROVIDING_LOCATION':
         return ServiceLocationType.SERVICE_PROVIDING_LOCATION;

      case 'HEALTHCARE_FACILITY_LOCATION':
         return ServiceLocationType.HEALTHCARE_FACILITY_LOCATION;

      case 'HEALTHCARE_FACILITY_UNIT':
         return ServiceLocationType.HEALTHCARE_FACILITY_UNIT;

      default:
         return assertUnreachable(healthcareProviderLocationType);
   }
};

export const getWarningMessage = (
   receptionServiceValue: ReceptionServiceTableBean[],
   healthcareProviderLocationValue: HealthcareProviderLocation | null
): string | null => {
   if (!healthcareProviderLocationValue || receptionServiceValue.length === 0) {
      return null;
   }

   const currentServiceLocationId = ServiceLocationId.of(
      mapHealthcareProviderLocationTypeToServiceLocationType(healthcareProviderLocationValue.locationIdentifier.type),
      healthcareProviderLocationValue.locationIdentifier.locationId
   ).asString();

   const allReceptionServicesHasCurrentServiceLocation = receptionServiceValue.every(({ receptionService }) =>
      receptionService.serviceLocationIds.some(
         (serviceLocationId) => serviceLocationId.asString() === currentServiceLocationId
      )
   );

   if (allReceptionServicesHasCurrentServiceLocation) {
      return null;
   }

   return appointmentsTranslationKeys.serviceLocationWarning.notAllServicesAreRealizedInSelectedServiceLocation;
};
